/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { JourFermetureGlobaleDto } from '../models/jour-fermeture-globale-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des jours de fermeture globale
 */
@Injectable({
  providedIn: 'root',
})
export class JoursFermetureGlobaleService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation jourFermetureGlobaleGet
   */
  static readonly JourFermetureGlobaleGetPath = '/api/jours-fermeture-globale/{id}';

  /**
   * Renvoie le jour de fermeture globale spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jourFermetureGlobaleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  jourFermetureGlobaleGet$Response(params: {

    /**
     * Identifiant du jour de fermeture globale
     */
    id: number;
  }): Observable<StrictHttpResponse<JourFermetureGlobaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, JoursFermetureGlobaleService.JourFermetureGlobaleGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JourFermetureGlobaleDto>;
      })
    );
  }

  /**
   * Renvoie le jour de fermeture globale spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jourFermetureGlobaleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jourFermetureGlobaleGet(params: {

    /**
     * Identifiant du jour de fermeture globale
     */
    id: number;
  }): Observable<JourFermetureGlobaleDto> {

    return this.jourFermetureGlobaleGet$Response(params).pipe(
      map((r: StrictHttpResponse<JourFermetureGlobaleDto>) => r.body as JourFermetureGlobaleDto)
    );
  }

  /**
   * Path part for operation jourFermetureGlobalePut
   */
  static readonly JourFermetureGlobalePutPath = '/api/jours-fermeture-globale/{id}';

  /**
   * Met à jour le jour de fermeture globale spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jourFermetureGlobalePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jourFermetureGlobalePut$Response(params: {

    /**
     * Identifiant du jour de fermeture globale à mettre à jour
     */
    id: number;

    /**
     * Jour de fermeture globale
     */
    body: JourFermetureGlobaleDto
  }): Observable<StrictHttpResponse<JourFermetureGlobaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, JoursFermetureGlobaleService.JourFermetureGlobalePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JourFermetureGlobaleDto>;
      })
    );
  }

  /**
   * Met à jour le jour de fermeture globale spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jourFermetureGlobalePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jourFermetureGlobalePut(params: {

    /**
     * Identifiant du jour de fermeture globale à mettre à jour
     */
    id: number;

    /**
     * Jour de fermeture globale
     */
    body: JourFermetureGlobaleDto
  }): Observable<JourFermetureGlobaleDto> {

    return this.jourFermetureGlobalePut$Response(params).pipe(
      map((r: StrictHttpResponse<JourFermetureGlobaleDto>) => r.body as JourFermetureGlobaleDto)
    );
  }

  /**
   * Path part for operation jourFermetureGlobaleDelete
   */
  static readonly JourFermetureGlobaleDeletePath = '/api/jours-fermeture-globale/{id}';

  /**
   * Supprime le jour de fermeture globale spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jourFermetureGlobaleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  jourFermetureGlobaleDelete$Response(params: {

    /**
     * Identifiant du jour de fermeture globale à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, JoursFermetureGlobaleService.JourFermetureGlobaleDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le jour de fermeture globale spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jourFermetureGlobaleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jourFermetureGlobaleDelete(params: {

    /**
     * Identifiant du jour de fermeture globale à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.jourFermetureGlobaleDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation jourFermetureGlobaleGetList
   */
  static readonly JourFermetureGlobaleGetListPath = '/api/jours-fermeture-globale/list';

  /**
   * Renvoie la liste des jours de fermeture globale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jourFermetureGlobaleGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  jourFermetureGlobaleGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<JourFermetureGlobaleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, JoursFermetureGlobaleService.JourFermetureGlobaleGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<JourFermetureGlobaleDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des jours de fermeture globale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jourFermetureGlobaleGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jourFermetureGlobaleGetList(params?: {
  }): Observable<Array<JourFermetureGlobaleDto>> {

    return this.jourFermetureGlobaleGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<JourFermetureGlobaleDto>>) => r.body as Array<JourFermetureGlobaleDto>)
    );
  }

  /**
   * Path part for operation jourFermetureGlobaleLoadList
   */
  static readonly JourFermetureGlobaleLoadListPath = '/api/jours-fermeture-globale/load-list';

  /**
   * Renvoie la liste des jours de fermeture globale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jourFermetureGlobaleLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jourFermetureGlobaleLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, JoursFermetureGlobaleService.JourFermetureGlobaleLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des jours de fermeture globale (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jourFermetureGlobaleLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jourFermetureGlobaleLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.jourFermetureGlobaleLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation jourFermetureGlobalePost
   */
  static readonly JourFermetureGlobalePostPath = '/api/jours-fermeture-globale';

  /**
   * Crée un jour de fermeture globale.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jourFermetureGlobalePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jourFermetureGlobalePost$Response(params: {

    /**
     * Jour de fermeture globale
     */
    body: JourFermetureGlobaleDto
  }): Observable<StrictHttpResponse<JourFermetureGlobaleDto>> {

    const rb = new RequestBuilder(this.rootUrl, JoursFermetureGlobaleService.JourFermetureGlobalePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<JourFermetureGlobaleDto>;
      })
    );
  }

  /**
   * Crée un jour de fermeture globale.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jourFermetureGlobalePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jourFermetureGlobalePost(params: {

    /**
     * Jour de fermeture globale
     */
    body: JourFermetureGlobaleDto
  }): Observable<JourFermetureGlobaleDto> {

    return this.jourFermetureGlobalePost$Response(params).pipe(
      map((r: StrictHttpResponse<JourFermetureGlobaleDto>) => r.body as JourFermetureGlobaleDto)
    );
  }

}
